import React, { useRef, useEffect } from "react"
// import paidData from "./paidData.json"
import Chart from "react-apexcharts"
import { METRICS_HISTORY_QUERY, METRICS_QUERY } from "AdminApp"
import { useQuery } from "@apollo/client"

const PaidChart = () => {
  const { data: latest } = useQuery(METRICS_QUERY)
  const { data: history } = useQuery(METRICS_HISTORY_QUERY)
  console.log("metricsHistory", history)
  const data = [...(history?._metricsHistory ?? [])]
  if (latest?._metrics) {
    data.unshift({ ...latest._metrics, date: new Date().toISOString() })
  }
  const dataWithoutTime = data?.map((el) => {
    const next = { ...el }
    next.date = el.date.split(" ")[0]
    return next
  })

  const filtered = dataWithoutTime
    ?.filter((v, i, a) => a.findIndex((v2) => v2.date === v.date) === i)
    .reverse()

  const dates = filtered?.map((el) => el.date)
  const paidUsers = filtered?.map((el) => el.numPaidUsers)

  const chartInfo = {
    options: {
      chart: {
        id: "apexchart-example",
      },
      xaxis: {
        categories: dates,
      },
    },
    series: [
      {
        name: "paid users",
        data: paidUsers,
      },
    ],
    stroke: {
      curve: "smooth",
    },
  }
  if (!data) return null
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        display: "flex",
        position: "fixed",
        zIndex: 200,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Chart
        options={chartInfo.options}
        series={chartInfo.series}
        type="line"
        width={800}
        height={400}
      />
    </div>
  )
}

export default PaidChart
